import { render, staticRenderFns } from "./LPagination.vue?vue&type=template&id=1bed81a2&scoped=true"
import script from "./LPagination.vue?vue&type=script&lang=js"
export * from "./LPagination.vue?vue&type=script&lang=js"
import style0 from "./LPagination.vue?vue&type=style&index=0&id=1bed81a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bed81a2",
  null
  
)

export default component.exports